import { EndpointURLScheme } from "@smithy/types";
import { isIpAddress } from "./isIpAddress";
const DEFAULT_PORTS = {
  [EndpointURLScheme.HTTP]: 80,
  [EndpointURLScheme.HTTPS]: 443
};
export const parseURL = value => {
  const whatwgURL = (() => {
    try {
      if (value instanceof URL) {
        return value;
      }
      if (typeof value === "object" && "hostname" in value) {
        const {
          hostname,
          port,
          protocol = "",
          path = "",
          query = {}
        } = value;
        const url = new URL("".concat(protocol, "//").concat(hostname).concat(port ? ":".concat(port) : "").concat(path));
        url.search = Object.entries(query).map(_ref => {
          let [k, v] = _ref;
          return "".concat(k, "=").concat(v);
        }).join("&");
        return url;
      }
      return new URL(value);
    } catch (error) {
      return null;
    }
  })();
  if (!whatwgURL) {
    console.error("Unable to parse ".concat(JSON.stringify(value), " as a whatwg URL."));
    return null;
  }
  const urlString = whatwgURL.href;
  const {
    host,
    hostname,
    pathname,
    protocol,
    search
  } = whatwgURL;
  if (search) {
    return null;
  }
  const scheme = protocol.slice(0, -1);
  if (!Object.values(EndpointURLScheme).includes(scheme)) {
    return null;
  }
  const isIp = isIpAddress(hostname);
  const inputContainsDefaultPort = urlString.includes("".concat(host, ":").concat(DEFAULT_PORTS[scheme])) || typeof value === "string" && value.includes("".concat(host, ":").concat(DEFAULT_PORTS[scheme]));
  const authority = "".concat(host).concat(inputContainsDefaultPort ? ":".concat(DEFAULT_PORTS[scheme]) : "");
  return {
    scheme,
    authority,
    path: pathname,
    normalizedPath: pathname.endsWith("/") ? pathname : "".concat(pathname, "/"),
    isIp
  };
};